/**
 * footer.js — Componente de footer DRY.
 * Injeta o HTML do footer no placeholder #site-footer.
 * Chamado por main.js (index) e pelos scripts de página.
 */

const FOOTER_HTML = /* html */`
<footer class="site-footer">
  <div class="container footer-grid">
    <div class="footer-brand">
      <div class="header-brand-cluster" style="margin-bottom: 1.5rem;">
        <a href="/" class="brand-icon" id="footer-brand-icon" aria-label="Home" data-config="brand_initial" style="display:none;">A</a>
        <a href="/" class="logo" id="footer-brand-name" data-config="nome_loja" style="display:none;">Lex Veículos</a>
        <a href="/" class="header-logo-link" id="footer-brand-logo-link" aria-label="Início">
          <img id="footer-brand-logo-img" class="header-logo-img" src="/logo-auto-maia.webp" alt="Lex Veículos" style="max-height: 32px;" />
        </a>
      </div>
      <p class="footer-desc" data-config="descricao_curta">
        Procurando lojas de carro? A Lex Veículos é a sua melhor loja de veículos em Caldas Novas (CN). Compra, venda e financiamento de carros novos e seminovos em Caldas Novas - GO.
      </p>
      <div class="footer-socials">
        <!-- WhatsApp: visível por padrão, oculto se não configurado -->
        <a id="footer-whatsapp" href="#" class="social-link" aria-label="WhatsApp" target="_blank" rel="noopener">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
          </svg>
        </a>
        <!-- Instagram -->
        <a id="footer-instagram" href="#" class="social-link" aria-label="Instagram" target="_blank" rel="noopener" style="display:none;">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"
            stroke-linecap="round" stroke-linejoin="round">
            <rect width="20" height="20" x="2" y="2" rx="5" ry="5" />
            <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
            <line x1="17.5" x2="17.51" y1="6.5" y2="6.5" />
          </svg>
        </a>
        <!-- Facebook -->
        <a id="footer-facebook" href="#" class="social-link" aria-label="Facebook" target="_blank" rel="noopener" style="display:none;">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
            <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
          </svg>
        </a>
        <!-- YouTube -->
        <a id="footer-youtube" href="#" class="social-link" aria-label="YouTube" target="_blank" rel="noopener" style="display:none;">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
            <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
          </svg>
        </a>
        <!-- TikTok -->
        <a id="footer-tiktok" href="#" class="social-link" aria-label="TikTok" target="_blank" rel="noopener" style="display:none;">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
            <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.27 6.27 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.69a8.18 8.18 0 0 0 4.78 1.52V6.74a4.85 4.85 0 0 1-1.01-.05z"/>
          </svg>
        </a>
      </div>
    </div>

    <div class="footer-col">
      <h4 class="footer-heading">Empresa</h4>
      <ul class="footer-links">
        <li><a href="/sobre">Sobre nós</a></li>
        <li><a href="/estoque">Nosso Estoque</a></li>
        <li><a href="/#agendar">Fale Conosco</a></li>
      </ul>
    </div>

    <div class="footer-col">
      <h4 class="footer-heading">Serviços</h4>
      <ul class="footer-links">
        <li><a href="/financiamento">Financie seu Carro</a></li>
      </ul>
    </div>

    <div class="footer-col">
      <h4 class="footer-heading">Legal</h4>
      <ul class="footer-links">
        <li><a href="/termos">Termos de Uso</a></li>
        <li><a href="/privacidade">Privacidade</a></li>
      </ul>
    </div>
  </div>

  <div class="container footer-bottom">
    <p>© ${new Date().getFullYear()} <span data-config="nome_loja">Lex Veículos</span> Veículos. Todos os direitos reservados.</p>
  </div>
</footer>
`;

/**
 * Injeta o footer no placeholder #site-footer.
 * Deve ser chamado antes de applyConfiguracoes() para que os
 * data-config e IDs do footer já existam no DOM quando a config for aplicada.
 */
export function renderFooter() {
  const placeholder = document.getElementById('site-footer');
  if (!placeholder) return;
  placeholder.outerHTML = FOOTER_HTML;
}
